<template>
  <v-container fluid>
    <v-row no-gutters class="pb-4">
      <v-col cols="12"
        ><h2 class="primary300--text text-left text-capitalize">
          {{ setTitle() }}
        </h2></v-col
      >
    </v-row>
    <v-progress-linear
      v-show="providerLoading"
      color="neutral400"
      indeterminate
      rounded
      height="3"
    ></v-progress-linear>
    <div v-if="!providerLoading && providers.length === 0">
      <div>No data found for the specified criteria</div>
    </div>
    <v-row class="mb-1">
      <v-col
        xl="6"
        sm="6"
        lg="6"
        md="6"
        cols="12"
        class="pa-xs-1 pa-sm-1 pa-md-4"
        v-for="provider in providers"
        :key="'provider-' + provider.id"
      >
        <v-card class="provider-card my-2" @click="onProviderClick(provider)">
          <v-row class="pa-3">
            <v-col cols="12" lg="3" sm="3" xl="3" md="2" class="text-center">
              <v-avatar size="100">
                <v-img contain :src="provider.logoUrl">
                  <template v-slot:placeholder>
                    <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                  </template>
                </v-img>
              </v-avatar>
            </v-col>
            <v-col class="text-left" cols="12" md="10" lg="9" sm="9" xl="9">
              <div class="d-flex flex-row">
                <div>
                  <h3 class="mb-1 neutral800--text">
                    <text-highlight :queries="queries">{{ provider.name }}</text-highlight>
                  </h3>
                  <div class="mb-1">
                    <span class="font-weight-bold neutral700--text">Hosting Institution: </span>
                    <text-highlight :queries="queries"
                      >{{ provider.hostingInstitution.name }}
                    </text-highlight>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <div
                  class="hidden-sm-and-down text-right"
                  v-if="roles && roles.indexOf('super-admin') >= 0"
                >
                  <v-btn style="background: white" @click="onEditItem(provider)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </div>
                <div
                  class="hidden-sm-and-down text-right"
                  v-if="providerId != provider.id && provider.publicContactsVerified.length > 0"
                >
                  <v-btn
                    v-if="!roles"
                    style="background: white"
                    @click.stop="onContactItem(provider)"
                  >
                    <v-icon>mdi-email-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    style="background: white"
                    @click.stop=""
                    :href="'mailto:' + provider.publicContactsVerified[0].email"
                  >
                    <v-icon>mdi-email-outline</v-icon>
                  </v-btn>
                </div>
              </div>
              <div @click.stop="">
                <span class="font-weight-bold neutral700--text">Website: </span>
                <a
                  target="_blank"
                  style="z-index: 9 !important;"
                  :href="provider.website"
                  class="on-hover-underline"
                  >{{ provider.website }}</a
                >
              </div>
              <div class="mb-1 d-flex flex-row align-center" v-if="provider.socialMedia.length > 0">
                <div class="font-weight-bold neutral700--text">Social Media:</div>
                <social-media :list="provider.socialMedia" :icon-size="18"></social-media>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="providers.length > 0" class="custom-pagination">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ providersLength }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="itemsPerPage"
            :items="[5, 10, 15, 25, 50, 100]"
            dense
            outlined
            hide-details
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="4" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-dialog v-model="modalLogIn" max-width="1000px">
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="px-0 py-0">
          <v-row class="mx-0 px-2" align="center">
            <v-col cols="11" class="text-center d-flex justify-center align-center">
              This action requires authentication
            </v-col>
            <v-col cols="1" class="pl-0">
              <v-btn fab small text @click="modalLogIn = false">
                <v-icon color="neutral500">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
        <v-card-text class="pa-0">
          Only authenticated users are allowed to perform this action. Please
          <router-link :to="{ name: 'MarketplaceProvider', params: { id: itemSelectedId } }"
            >Log In</router-link
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TextHighlight from 'vue-text-highlight';
import SocialMedia from '@/components/marketplace/SocialMedia';
import service from '@/services/base-service';
import util from '@/mixins/util.js';

export default {
  name: 'MarketplaceProvidersComponent',
  components: {
    SocialMedia,
    TextHighlight,
  },
  mixins: [service, util],
  data() {
    return {
      firstLoad: true,
      providers: [],
      providersLength: null,
      providerId: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      search: {},
      searchAttributes: ['text', 'institutions', 'domains', 'subDomains', 'structureTypes'],
      pagesLength: 1,
      itemsPerPage: 10,
      queries: null,
      providerLoading: true,
      roles: null,
      modalLogIn: false,
      institutions: [],
      itemSelectedId: null,
    };
  },
  created() {
    this.providerId = sessionStorage.getItem('providerId');
    this.roles = localStorage.getItem('roles');
    this.getInstitutions().then(res => {
      this.institutions = res.data;
    });
  },
  mounted() {
    /* Populate table from route */
    this.options.page = this.$route.query.index ? Number(this.$route.query.index) + 1 : 1;
    this.options.itemsPerPage = this.$route.query.size ? Number(this.$route.query.size) : 10;
    this.options.sortBy = [];
    this.options.sortDesc = [];
    if (this.$route.query.sort) {
      const sortList = this.$route.query.sort.split(',');
      for (let i = 0; i < sortList.length; i += 1) {
        this.options.sortBy.push(sortList[i].split(' ')[0]);
        if (sortList[i].split(' ')[1] === 'asc') {
          this.options.sortDesc.push(false);
        } else {
          this.options.sortDesc.push(true);
        }
      }
    }
    for (let i = 0; i < this.searchAttributes.length; i += 1) {
      const attr = this.searchAttributes[i];
      if (this.$route.query[attr]) {
        this.$set(this.search, attr, this.$route.query[attr]);
      }
    }
    this.itemsPerPage = this.options.itemsPerPage;
    this.getDataFromApi();
    this.queries = this.$route.query.text ? this.$route.query.text : '';
  },
  methods: {
    onProviderClick(item) {
      if (!this.$router.currentRoute.meta.requiresAuth) {
        this.$router.push({
          name: 'PublicMarketplaceProvider',
          params: { id: item.id },
        });
      } else {
        this.$router.push({
          name: 'MarketplaceProvider',
          params: { id: item.id },
        });
      }
    },
    getDataFromApi() {
      this.providerLoading = true;
      this.axios
        .get('/api/v1/providers?', {
          params: this.getParams(),
        })
        .then(res => {
          this.providers = res.data.content;
          this.pagesLength = res.data.pagesLength;
          this.firstLoad = false;
          this.providersLength = res.data.total;
          this.$emit('providersLength', res.data.total);
        })
        .finally(() => {
          this.providerLoading = false;
        });
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const query = {
        index: page - 1,
        size: itemsPerPage,
      };
      let sort = '';
      for (let i = 0; i < sortBy.length; i += 1) {
        if (i !== 0) {
          sort += ',';
        }
        let dir = 'asc';
        if (sortDesc[i]) {
          dir = 'desc';
        }
        sort += `${sortBy[i]} ${dir}`;
      }
      if (sort !== '') {
        query.sort = sort;
      }
      for (let i = 0; i < this.searchAttributes.length; i += 1) {
        const attr = this.searchAttributes[i];
        if (this.search[attr]) {
          query[attr] = this.search[attr];
        }
      }
      return query;
    },
    changeOptions() {
      console.log('change options');
      this.$router
        .push({
          path: this.$router.path,
          query: this.getParams(),
        })
        .catch(err => {
          throw new Error(`Problem handling something: ${err}.`);
        });
    },
    setTitle() {
      if (this.countFilters(this.search) > 1) {
        return 'Multiple Filters Applied';
      } else if (this.search.institutions && this.search.institutions.length > 0) {
        let institutions = [];
        const ids = this.search.institutions.split(',');
        for (let id of ids) {
          const inst = this.institutions.find(element => element.id == id);
          if (inst) {
            institutions.push(inst.name);
          }
        }
        return institutions.join(', ');
      } else if (this.search.domains && this.search.domains.length > 0) {
        return this.search.domains;
      } else if (this.search.categories && this.search.categories.length > 0) {
        return this.search.categories;
      }
    },
    onEditItem(value) {
      console.log('Click Edit ' + value.id);
      this.$router.push({
        name: 'EditProvider',
        params: { id: value.id },
      });
    },
    onContactItem(value) {
      console.log('Contact ' + value.id);
      this.itemSelectedId = value.id;
      this.modalLogIn = true;
    },
  },
  watch: {
    options: {
      handler() {
        console.log('[Table] Options watch');
        if (!this.firstLoad) {
          this.changeOptions();
        }
      },
      deep: true,
    },
    itemsPerPage(value) {
      if (!this.firstLoad) {
        this.options = {
          ...this.options,
          itemsPerPage: value,
          page: 1,
        };
      }
    },
  },
};
</script>

<style scoped>
.provider-card {
  box-shadow: 0.869231px 3.47692px 37.3769px -7.82308px rgb(80 67 199 / 20%) !important;
  border-radius: 30px !important;
  border: unset !important;
  cursor: pointer;
}

.provider-card:hover {
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%),
    0px 1px 10px 0px rgb(0 0 0 / 12%) !important;
}
</style>
